( function ($) {
    const $notification = $('.notification');

    if ($notification.hasClass('.auto-close')) {
        setTimeout( function () {
            $notification.remove();
        }, 5000);
    }

    $notification.on('click', '.close-notification', function (event) {
        event.preventDefault();

        $(this).parent().remove();
    });

}(jQuery));
